<script setup>
import { primariaServizioPage } from '@/graphql/queries/servizi-nav.js'

definePageMeta({
  layout: 'default',
})

const route = useRoute()
const slug = route.params.slug

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
  slug,
}))

const { data: pageData } = await useGraphql(primariaServizioPage, variables)

const page = computed(() => pageData?.value?.primariaServizio || {})
const seo = computed(() => page?.value?.seo || {})
const primariaServizi = computed(
  () => pageData?.value?.allPrimariaServizios || [],
)
useSeo(seo)

const category = computed(() => {
  if (route.path.includes('/infanzia/')) {
    return 'infanzia'
  } else if (route.path.includes('/primaria/')) {
    return 'primaria'
  }
  return ''
})

const hasHero = computed(() => !!page.value.hero)
</script>

<template>
  <div class="primaria-servizio-page-wrap">
    <div class="primaria-servizio-page flex is-reverse">
      <div :class="['content-with-sidebar', { 'm-top-xl-1': !hasHero }]">
        <LazyServiziHero v-if="page.hero" :hero="page.hero" />
        <template v-if="page.body && page.body.length">
          <section v-for="item in page.body" :key="item.id">
            <template v-if="item.__typename === 'CaroselloRecord'">
              <LazySwiperSlider
                v-if="item && item.slide && item.slide.length"
                :slides="item.slide"
                type="offset-type"
                class="p-top-xl-1"
              />
            </template>
            <template
              v-if="item.__typename === 'TitoloTestoDoppiaColonnaRecord'"
            >
              <LazyTitleDoubleColText
                class="row-130-25"
                :block="item"
                type="custom-position"
              />
            </template>
            <template v-if="item.__typename === 'ImmagineTestoRecord'">
              <LazyImgText
                id="laboratori"
                :block="item"
                :type="
                  item.immagineADestra
                    ? 'reverse in-detail-page'
                    : 'default in-detail-page'
                "
                :max-content="true"
                image-shape="capsule"
              />
            </template>
            <template v-if="item.__typename === 'TestoImmagineWideRecord'">
              <LazyTextImageWide :block="item" />
            </template>
            <template
              v-if="item.__typename === 'SezioneImmagineTestoCardRecord'"
            >
              <LazyImgTextCards :block="item" />
            </template>
            <template v-if="item.__typename === 'SezioneTabellaRecord'">
              <LazyTableBlock :block="item" />
            </template>
            <template v-if="item.__typename === 'SezioneRecensioniRecord'">
              <div class="row-130-25 p-top-xl-1">
                <LazyRecensioni :block="item" />
              </div>
            </template>
          </section>
        </template>
      </div>
      <div class="sidebar show-for-large">
        <FixedSideMenu :servizi="primariaServizi" :category="category" />
      </div>
    </div>
    <div class="p-top-xl-1">
      <LazyDoubleBlockText
        v-if="page.bloccoVisite"
        :block="page.bloccoVisite"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServizioPrimaria',
}
</script>
